import { combineReducers } from 'redux';

import auth from './auth/reducer';
import user from './user/reducer';
import status from './status/reducer';

export default combineReducers({
    auth,
    user,
    status,
});
